import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";
import Slideshow from "../../assets/Slideshow/Slideshow";
import "./PersonalProjects.css";

import facemodel1 from "../../assets/Images/facemodel/1.jpg";
import facemodel2 from "../../assets/Images/facemodel/2.gif";
import facemodel3 from "../../assets/Images/facemodel/3.png";
import facemodel4 from "../../assets/Images/facemodel/4.png";
import facemodel6 from "../../assets/Images/facemodel/6.png";


import facemodel5 from "../../assets/Images/facemodel/5.mp4";





const FaceModel3D = () => {
  // Add your visuals later:
  // - notebook / procreate sketches
  // - LiDAR scan screenshots
  // - blender sculpting + decimate before/after
  // - shading tests (flat/stylized)
  // - ambient occlusion lighting test
  // - React Three Fiber render on homepage
  const images = [facemodel1,facemodel2,facemodel3,facemodel4,facemodel5,facemodel6];

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="page-container">
      <Navbar />

      <div className="content-lo1-headings">
        <h1>3D Face Model for Homepage</h1>
        <p>
          A personal experiment to make my portfolio homepage feel more alive — a 3D face model rendered
          with React Three Fiber (and soon: eyes that follow your cursor).
        </p>
      </div>

      <div className="line"></div>

      <div className="breadcrumb-wrap" style={{ padding: "0.1rem 7.5rem" }}>
        <BreadcrumbHeader />
      </div>

      <div className="content-lo1">
        <div className="pp-layout">
          {/* LEFT */}
          <div className="pp-left">
            <div className="pp-anchors">
              <button onClick={() => scrollToId("concept")}>Concept</button>
              <button onClick={() => scrollToId("value")}>Why it matters</button>
              <button onClick={() => scrollToId("process")}>Process</button>
              <button onClick={() => scrollToId("iteration")}>Iterations</button>
              <button onClick={() => scrollToId("next")}>What’s next</button>
            </div>

            <section id="concept" className="pp-section">
              <h2>Concept</h2>
              <p>
                I wanted my homepage to leave a strong first impression. After feedback from my teacher Amer,
                I decided to build a 3D face model that sits on the homepage and (eventually) reacts to the
                viewer by following the cursor.
              </p>
              <p>
                The goal is simple: make the portfolio feel responsive and interactive instead of just being
                a static landing page.
              </p>
            </section>

            <section id="value" className="pp-section">
              <h2>User Problem & Value</h2>
              <p>
                A lot of student portfolios follow the same layout and end up feeling similar. This 3D element
                helps my portfolio stand out because it’s memorable and feels personal.
              </p>
              <ul>
                <li>More engaging than a static hero section</li>
                <li>Shows creativity + technical curiosity</li>
                <li>Fits my interest in interactive web + design</li>
              </ul>
            </section>

            <section id="process" className="pp-section">
              <h2>Design Process</h2>
              <ul>
                <li>
                  <b>Wireframe / Lo-fi:</b> sketched ideas in my notebook to plan how the model would sit on the homepage
                </li>
                <li>
                  <b>Lo → Mid-fi:</b> tried creating a face model concept in Procreate to test the vibe and animation idea
                </li>
                <li>
                  <b>Hi-fi:</b> imported a 3D face scan into Blender, sculpted it, styled it, and rendered it on my website using React Three Fiber
                </li>
              </ul>

              <div className="pp-snapshot">
                <div className="pp-snapshot-item">
                  <span className="pp-label">Tools</span>
                  <span className="pp-value">LiDAR scan, Blender, React Three Fiber</span>
                </div>
                <div className="pp-snapshot-item">
                  <span className="pp-label">Goal</span>
                  <span className="pp-value">Interactive homepage element (performance-friendly)</span>
                </div>
                <div className="pp-snapshot-item">
                  <span className="pp-label">Style</span>
                  <span className="pp-value">Stylized / sculpture-like (less uncanny)</span>
                </div>
              </div>
            </section>

            <section id="iteration" className="pp-section">
              <h2>Iterations & Feedback</h2>

              <h3>Making it lighter (Josh)</h3>
              <p>
                After importing the LiDAR scan, Josh pointed out the model was too heavy for a website.
                I used Blender’s <b>Decimate</b> modifier to reduce polygons so it loads smoother without lag.
              </p>

              <h3>Making it less uncanny (Jan)</h3>
              <p>
                An early version looked a bit too realistic and felt uncanny. Based on Jan’s feedback,
                I leaned into a more stylized sculpted look instead of full realism.
              </p>

              <h3>Playing with shading</h3>
              <p>
                I experimented with flat and stylized materials to avoid “too real” vibes and match the creative
                tone of the site.
              </p>

              <h3>Lighting depth (Chris)</h3>
              <p>
                Chris suggested I explore <b>ambient occlusion</b> to improve depth and shading. It helped bring out
                details in a more natural way without making the face feel lifelike.
              </p>

              <h3>Integrating into the homepage</h3>
              <p>
                Once it was optimized and styled, I placed it on my homepage using <b>React Three Fiber</b>. Even without
                full interaction yet, it already gives the homepage a unique identity.
              </p>
            </section>

            <section id="next" className="pp-section">
              <h2>What’s Next</h2>
              <p>
                The next step is to make the eyes follow the user’s cursor. That’s still in progress, but it’s the
                feature that will make the model feel truly “alive”.
              </p>
              <p>
                Even unfinished, this project already shows the direction I like: mixing 3D, web dev, and user experience
                to build something that feels different.
              </p>
            </section>
          </div>

          {/* RIGHT */}
          <aside className="pp-right">
            {images.length > 0 ? (
              <Slideshow images={images} />
            ) : (
              <div className="slideshow-placeholder">
                <p>Slideshow Placeholder</p>
                <p>Add images to the images array to display slideshow</p>
              </div>
            )}

            <div className="pp-caption">
              <p>
                
              </p>
            </div>
          </aside>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FaceModel3D;
